import React from "react";
import { GlobalStyles, useTheme } from "@mui/material";

export const CustomSiderStyles: React.FC = () => {
  const theme = useTheme();

  return (
    <GlobalStyles
      styles={{
        // Suppression du soulignement des liens par défaut
        "a": {
          textDecoration: "none !important",
        },

        // Styles pour la sidebar et les éléments de navigation
        ".MuiDrawer-root": {
          height: "100% !important",
        },
        ".MuiDrawer-paper": {
          height: "100% !important",
          backgroundColor: theme.palette.mode === "dark"
            ? theme.palette.grey[900]
            : theme.palette.background.paper,
          padding: "16px",
          position: "relative",
          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important",
          overflow: "hidden !important",
          display: "flex",
          flexDirection: "column",
        },


        // Supprimer le padding-top de la liste
        ".MuiList-root": {
          paddingTop: "0 !important",
        },

        // Styles pour les éléments de navigation (pills)
        ".MuiList-root .MuiListItem-root": {
          padding: "4px 0 !important",
          marginBottom: "4px !important",
        },

        ".MuiList-root .MuiListItemButton-root": {
          borderRadius: "12px !important",
          padding: "12px 16px !important",
          margin: "0 !important",
          minHeight: "48px !important",
          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important",
          position: "relative !important",
          justifyContent: "flex-start !important",

          "&:before": {
            content: '""',
            position: "absolute",
            left: "0",
            top: "50%",
            transform: "translateY(-50%)",
            width: "3px",
            height: "0px",
            backgroundColor: theme.palette.primary.main,
            borderRadius: "0 2px 2px 0",
            transition: "height 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          },
        },

        // Styles pour l'élément actif
        ".MuiList-root .MuiListItemButton-root.Mui-selected": {
          backgroundColor: `${theme.palette.primary.main} !important`,
          color: `${theme.palette.primary.contrastText} !important`,

          "&:hover": {
            backgroundColor: `${theme.palette.primary.main} !important`,
          },

          "&:before": {
            height: "24px !important",
            backgroundColor: `${theme.palette.primary.contrastText} !important`,
          },

          "& .MuiListItemIcon-root": {
            color: `${theme.palette.primary.contrastText} !important`,
          },

          "& .MuiListItemText-root .MuiTypography-root": {
            color: `${theme.palette.primary.contrastText} !important`,
            fontWeight: "600 !important",
          },
        },

        // Styles pour les icônes
        ".MuiList-root .MuiListItemIcon-root": {
          minWidth: "40px !important",
          justifyContent: "flex-start !important",
          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important",

          "& .MuiSvgIcon-root": {
            fontSize: "22px !important",
            transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important",
          },
        },

        // Styles pour le texte
        ".MuiList-root .MuiListItemText-root": {
          transition: "opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1), transform 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important",

          "& .MuiTypography-root": {
            fontSize: "14px !important",
            fontWeight: "500 !important",
          },
        },

        // Styles pour l'état non sélectionné avec hover
        ".MuiList-root .MuiListItemButton-root:not(.Mui-selected)": {
          backgroundColor: "transparent !important",
          color: theme.palette.text.primary,

          "&:hover": {
            backgroundColor: theme.palette.mode === "dark"
              ? `${theme.palette.grey[800]} !important`
              : `${theme.palette.grey[100]} !important`,
          },
        },

        // Animation pour l'état collapsed
        ".MuiDrawer-paper.MuiDrawer-paperAnchorLeft": {
          transition: "width 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important",
        },

        // Animation du backdrop en mobile
        ".MuiBackdrop-root": {
          transition: "opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important",
        },

        // Styles pour le mode collapsed - plus spécifique pour surcharger le padding
        ".MuiDrawer-root .MuiDrawer-paper.sidebar-collapsed": {
          padding: "8px 0 !important",

          "& .MuiList-root .MuiListItemButton-root": {
            justifyContent: "center !important",
            px: "12px !important",

            "& .MuiListItemIcon-root": {
              minWidth: "auto !important",
              mr: "0 !important",
            },

            "& .MuiListItemText-root": {
              opacity: "0 !important",
              transform: "translateX(-10px) !important",
              width: "0 !important",
              overflow: "hidden !important",
            },
          },
        },

        // // Styles pour le titre/logo
        // ".MuiList-root .MuiListItem-root:first-of-type": {
        //   paddingTop: "16px !important",
        //   paddingBottom: "16px !important",
        //   marginBottom: "8px !important",
        // },

        // Forcer la hauteur du menu ul à 100% pour qu'il occupe tout l'espace
        ".MuiBox-root > .MuiList-root": {
          height: "100% !important",
          display: "flex",
          flexDirection: "column",
        },

        // Styles pour le mode responsive
        "@media (max-width: 768px)": {
          ".MuiDrawer-root": {
            "& .MuiDrawer-paper": {
              backgroundColor: theme.palette.mode === "dark"
                ? `${theme.palette.grey[900]}dd`
                : `${theme.palette.background.paper}dd`,
              backdropFilter: "blur(10px)",
              transform: "translateX(-100%)",
              transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important",
              height: "100dvh !important", // Utiliser dvh pour une meilleure compatibilité mobile
              maxHeight: "100dvh !important",
              overflow: "hidden !important",
              display: "flex",
              flexDirection: "column",
              padding: "16px 16px env(safe-area-inset-bottom, 16px) 16px !important", // Ajouter safe area padding

              "&.MuiDrawer-paperAnchorLeft": {
                transform: "translateX(0)",
              },
              
              // S'assurer que le contenu interne est scrollable
              "& > div": {
                height: "100%",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
                
                "& > div:first-of-type": {
                  flex: "1 1 auto",
                  overflow: "auto",
                  minHeight: 0,
                  WebkitOverflowScrolling: "touch", // Smooth scrolling iOS
                },
              },
            },
          },

          // Animation pour le bouton hamburger
          ".MuiIconButton-root.MuiIconButton-edgeStart": {
            transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important",
            "&:active": {
              transform: "scale(0.95)",
            },
          },
        },
      }}
    />
  );
};
